(() => {
  if (window.__vivienneVariantGalleryFilter) return;
  window.__vivienneVariantGalleryFilter = true;

  const COLOR_OPTION_PATTERN = /(couleur|color|colour|kleur)/i;
  const IMAGE_SET_NAME = "couleur";
  const HIDDEN_CLASS = "vivienne-media-hidden";

  const ALIASES = {
    noir: ["noir", "black", "zwart"],
    blanc: ["blanc", "white", "wit"],
    marron: ["marron", "brown", "bruin", "cafe", "café", "dark-brown"],
    brun: ["brun", "brown", "bruin", "marron", "cafe", "café"],
    gris: ["gris", "gray", "grey", "grijs", "dark-gris", "light-gris"],
    bleu: ["bleu", "blue", "blauw", "bleu-clair", "light-blue", "navy", "marine"],
    rouge: ["rouge", "red", "rood"],
    vert: ["vert", "green", "groen", "olive", "army"],
    beige: ["beige", "apricot", "khaki"],
    creme: ["creme", "crème", "cream", "broken-white", "blanc-broken"],
    rose: ["rose", "pink"],
    violet: ["violet", "purple", "paars"],
    jaune: ["jaune", "yellow", "mustard"],
    orange: ["orange"],
    turquoise: ["turquoise"],
    taupe: ["taupe"],
    multicolore: ["multicolore", "multicolor", "printed", "print"]
  };

  function normalize(value) {
    return String(value || "")
      .replace(/\([^)]*\)/g, "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/&/g, " et ")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function canonicalColor(value) {
    const norm = normalize(value);
    if (!norm) return "";
    for (const [canonical, aliases] of Object.entries(ALIASES)) {
      if (aliases.some((alias) => {
        const a = normalize(alias);
        return norm === a || norm.includes(a) || a.includes(norm);
      })) return canonical;
    }
    return norm;
  }

  function themeHandle(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-$/, "")
      .replace(/^-/, "");
  }

  function urlKeys(value) {
    const raw = String(value || "");
    if (!raw) return [];
    const keys = new Set();
    raw.split(",").forEach((part) => {
      const cleaned = part.trim().split(/\s+/)[0];
      if (!cleaned) return;
      try {
        const url = new URL(cleaned, window.location.origin);
        const file = decodeURIComponent(url.pathname.split("/").pop() || "");
        const noSize = file.replace(/_(?:\d+x\d*|x\d+|\d+x|pico|icon|thumb|small|compact|medium|large|grande|master)(?=\.)/i, "");
        keys.add(noSize.toLowerCase());
        keys.add(noSize.split(".").slice(0, -1).join(".").toLowerCase());
      } catch (_) {}
    });
    return Array.from(keys).filter(Boolean);
  }

  function elementKeys(el) {
    const keys = new Set();
    const img = el.querySelector && el.querySelector("img");
    if (img) {
      [img.currentSrc, img.src, img.dataset ? img.dataset.src : "", img.getAttribute("srcset"), img.getAttribute("data-srcset")].forEach((value) => {
        urlKeys(value).forEach((key) => keys.add(key));
      });
    }
    ["href", "data-photoswipe-src", "data-src", "data-bgset"].forEach((attr) => {
      urlKeys(el.getAttribute && el.getAttribute(attr)).forEach((key) => keys.add(key));
    });
    return Array.from(keys);
  }

  function readVariants(section) {
    const node = section.querySelector("[data-variant-json]");
    if (!node) return [];
    try {
      return JSON.parse(node.value || node.textContent || "[]");
    } catch (_) {
      return [];
    }
  }

  function colorOptionIndex(section) {
    const swatch = section.querySelector(".variant__input--color-swatch[data-color-index]");
    if (swatch && swatch.dataset.colorIndex !== undefined) {
      const index = Number(swatch.dataset.colorIndex);
      if (!Number.isNaN(index)) return index;
    }

    const wraps = Array.from(section.querySelectorAll(".variant-input-wrap"));
    const match = wraps.find((wrap) => COLOR_OPTION_PATTERN.test(wrap.getAttribute("name") || wrap.dataset.handle || ""));
    if (match && /^option\d+$/i.test(match.dataset.index || "")) {
      return Number(match.dataset.index.replace(/\D/g, "")) - 1;
    }

    return -1;
  }

  function selectedColor(section, index) {
    const checked = section.querySelector(`.variant-input-wrap[data-index="option${index + 1}"] [data-variant-input]:checked`);
    if (checked) return canonicalColor(checked.value || checked.dataset.colorName || "");
    const variants = readVariants(section);
    const selectedId = section.querySelector("[data-product-select]") && section.querySelector("[data-product-select]").value;
    const variant = variants.find((item) => String(item.id) === String(selectedId)) || variants[0];
    return variant ? canonicalColor(variant[`option${index + 1}`]) : "";
  }

  function variantImageMap(section, index) {
    const map = new Map();
    readVariants(section).forEach((variant) => {
      const color = canonicalColor(variant[`option${index + 1}`]);
      const group = `${IMAGE_SET_NAME}_${themeHandle(variant[`option${index + 1}`])}`;
      const image = variant.featured_image || {};
      if (!color || !image.src) return;
      if (!map.has(color)) map.set(color, { imageKeys: new Set(), group });
      urlKeys(image.src).forEach((key) => map.get(color).imageKeys.add(key));
    });
    return map;
  }

  function colorFromFile(keys, knownColors) {
    const haystack = keys.join(" ");
    for (const color of knownColors) {
      const aliases = ALIASES[color] || [color];
      if (aliases.some((alias) => haystack.includes(normalize(alias)))) return color;
    }
    return "";
  }

  function annotateMedia(section) {
    const index = colorOptionIndex(section);
    if (index < 0) return { index, colors: new Map() };

    const colors = variantImageMap(section, index);
    const knownColors = Array.from(colors.keys());
    if (!knownColors.length) return { index, colors };

    const mediaEls = Array.from(section.querySelectorAll(".product-main-slide, .product__thumb-item"));
    mediaEls.forEach((el) => {
      const keys = elementKeys(el);
      const matched = [];

      colors.forEach((entry, color) => {
        if (keys.some((key) => entry.imageKeys.has(key))) matched.push(color);
      });

      const filenameColor = matched.length ? "" : colorFromFile(keys.map(normalize), knownColors);
      if (filenameColor) matched.push(filenameColor);

      const unique = Array.from(new Set(matched));
      if (!unique.length) return;

      el.dataset.vivienneColorGroups = unique.join(" ");
      el.dataset.setName = IMAGE_SET_NAME;
      el.dataset.group = colors.get(unique[0]) && colors.get(unique[0]).group
        ? colors.get(unique[0]).group
        : `${IMAGE_SET_NAME}_${unique[0]}`;
    });

    return { index, colors };
  }

  function applyFilter(section, variant) {
    const annotated = annotateMedia(section);
    if (annotated.index < 0 || !annotated.colors.size) return;

    const selected = variant ? canonicalColor(variant[`option${annotated.index + 1}`]) : selectedColor(section, annotated.index);
    if (!selected) return;

    const mainSlides = Array.from(section.querySelectorAll(".product-main-slide"));
    const thumbs = Array.from(section.querySelectorAll(".product__thumb-item"));
    const matchedThumbs = thumbs.filter((el) => (el.dataset.vivienneColorGroups || "").split(/\s+/).includes(selected));
    if (!matchedThumbs.length) return;

    mainSlides.forEach((el) => el.classList.remove(HIDDEN_CLASS));
    thumbs.forEach((el) => {
      const groups = (el.dataset.vivienneColorGroups || "").split(/\s+/).filter(Boolean);
      el.classList.toggle(HIDDEN_CLASS, !groups.includes(selected));
    });

    focusSelectedMedia(section, variant, matchedThumbs);
    window.setTimeout(() => window.dispatchEvent(new Event("resize")), 80);
  }

  function focusSelectedMedia(section, variant, matchedThumbs) {
    const variantKeys = new Set(urlKeys(variant && variant.featured_image && variant.featured_image.src));
    const targetThumb = matchedThumbs.find((thumb) => {
      if (!variantKeys.size) return false;
      return elementKeys(thumb).some((key) => variantKeys.has(key));
    }) || matchedThumbs[0];

    const trigger = targetThumb && targetThumb.querySelector("[data-product-thumb]");
    if (!trigger) return;

    window.setTimeout(() => {
      trigger.dispatchEvent(new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window
      }));
    }, 40);
  }

  function initSection(section) {
    annotateMedia(section);
    applyFilter(section);
  }

  function initAll() {
    document.querySelectorAll(".product-section[data-product-id]").forEach(initSection);
  }

  const style = document.createElement("style");
  style.setAttribute("data-vivienne-variant-gallery-filter", "true");
  style.textContent = `
    .product-section .product__thumb-item.vivienne-media-hidden {
      display: none !important;
    }
  `;
  document.head.appendChild(style);

  initAll();
  document.addEventListener("DOMContentLoaded", initAll, { once: true });
  document.addEventListener("page:loaded", initAll);
  document.addEventListener("variant:change", (event) => {
    const targetSection = event.target && event.target.closest ? event.target.closest(".product-section[data-product-id]") : null;
    const sections = targetSection ? [targetSection] : Array.from(document.querySelectorAll(".product-section[data-product-id]"));
    sections.forEach((section) => applyFilter(section, event.detail && event.detail.variant));
  }, true);
})();